"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const org_transcrypt___runtime___js_1 = require("./org.transcrypt.__runtime__.js");
const tfchain_polyfill_encoding_jsmods_sprintfjs_js_1 = require("./tfchain.polyfill.encoding.jsmods.sprintfjs.js");
var __name__ = 'tfchain.polyfill.encoding.str';
exports.to_int = function (str, base) {
    if (typeof base == 'undefined' || (base != null && base.hasOwnProperty("__kwargtrans__"))) {
        ;
        var base = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'str':
                        var str = __allkwargs0__[__attrib0__];
                        break;
                    case 'base':
                        var base = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var x = null;
    x = parseInt(str, base);
    return x;
};
exports.from_int = function (x) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'x':
                        var x = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var str = null;
    str = x.toString();
    return str;
};
exports.to_utf8 = function (str) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'str':
                        var str = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var bytes = null;
    bytes = new TextEncoder("utf-8").encode(str);
    return bytes;
};
exports.from_utf8 = function (bytes) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'bytes':
                        var bytes = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var str = null;
    str = new TextDecoder().decode(bytes);
    return str;
};
exports.from_float = function (f) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'f':
                        var f = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (org_transcrypt___runtime___js_1.isinstance(f, org_transcrypt___runtime___js_1.float)) {
        return org_transcrypt___runtime___js_1.str(f);
    }
    var out = '';
    out = f.toString();
    return out;
};
exports.zfill = function (s, n) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'n':
                        var n = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (org_transcrypt___runtime___js_1.len(s) >= n) {
        return s;
    }
    n -= org_transcrypt___runtime___js_1.len(s);
    s = '0'.repeat(n) + s;
    return s;
};
exports.zfillr = function (s, n) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'n':
                        var n = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (org_transcrypt___runtime___js_1.len(s) >= n) {
        return s;
    }
    n -= org_transcrypt___runtime___js_1.len(s);
    s += '0'.repeat(n);
    return s;
};
exports.lower = function (s) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    s = s.toLowerCase();
    return s;
};
exports.upper = function (s) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    s = s.toUpperCase();
    return s;
};
exports.rescape = function (s) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    s = s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return s;
};
exports.strip = function (s, c) {
    if (typeof c == 'undefined' || (c != null && c.hasOwnProperty("__kwargtrans__"))) {
        ;
        var c = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'c':
                        var c = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (c) {
        if (!(org_transcrypt___runtime___js_1.isinstance(c, org_transcrypt___runtime___js_1.str))) {
            var c = ''.join(c);
        }
        var c = exports.rescape(c);
        s = s.replace(new RegExp('[' + c + ']+', 'gi'), '');
    }
    else {
        s = s.trim();
    }
    return s;
};
exports.lstrip = function (s, c) {
    if (typeof c == 'undefined' || (c != null && c.hasOwnProperty("__kwargtrans__"))) {
        ;
        var c = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'c':
                        var c = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (c) {
        if (!(org_transcrypt___runtime___js_1.isinstance(c, org_transcrypt___runtime___js_1.str))) {
            var c = ''.join(c);
        }
        var c = exports.rescape(c);
        s = s.replace(new RegExp('^[' + c + ']+', 'i'), '');
    }
    else {
        s = s.trimLeft();
    }
    return s;
};
exports.rstrip = function (s, c) {
    if (typeof c == 'undefined' || (c != null && c.hasOwnProperty("__kwargtrans__"))) {
        ;
        var c = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'c':
                        var c = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (c) {
        if (!(org_transcrypt___runtime___js_1.isinstance(c, org_transcrypt___runtime___js_1.str))) {
            var c = ''.join(c);
        }
        var c = exports.rescape(c);
        s = s.replace(new RegExp('[' + c + ']+$', 'i'), '');
    }
    else {
        s = s.trimRight();
    }
    return s;
};
exports.py_replace = function (s, sub_old, sub_new) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'sub_old':
                        var sub_old = __allkwargs0__[__attrib0__];
                        break;
                    case 'sub_new':
                        var sub_new = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    s = s.replace(sub_old, sub_new);
    return s;
};
exports.replace_all = function (s, sub_old, sub_new) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'sub_old':
                        var sub_old = __allkwargs0__[__attrib0__];
                        break;
                    case 'sub_new':
                        var sub_new = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    s = s.replace(new RegExp(sub_old, 'g'), sub_new);
    return s;
};
exports.sprintf = function (fmt) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'fmt':
                        var fmt = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
        var argv = org_transcrypt___runtime___js_1.tuple([].slice.apply(arguments).slice(1, __ilastarg0__ + 1));
    }
    else {
        var argv = org_transcrypt___runtime___js_1.tuple();
    }
    return tfchain_polyfill_encoding_jsmods_sprintfjs_js_1.api(fmt, ...argv);
};
exports.py_split = function (s, c, limit) {
    if (typeof c == 'undefined' || (c != null && c.hasOwnProperty("__kwargtrans__"))) {
        ;
        var c = null;
    }
    ;
    if (typeof limit == 'undefined' || (limit != null && limit.hasOwnProperty("__kwargtrans__"))) {
        ;
        var limit = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'c':
                        var c = __allkwargs0__[__attrib0__];
                        break;
                    case 'limit':
                        var limit = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var c = c || '';
    if (!(org_transcrypt___runtime___js_1.isinstance(c, org_transcrypt___runtime___js_1.str))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('c is expected to be a str, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(c)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    var limit = org_transcrypt___runtime___js_1.max(-(1), limit || -(1));
    if (!(org_transcrypt___runtime___js_1.isinstance(limit, org_transcrypt___runtime___js_1.int))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('limit is expected to be an int, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(limit)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    var arr = null;
    arr = s.split(c, limit);
    return arr;
};
exports.repeat = function (s, count) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'count':
                        var count = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (!(org_transcrypt___runtime___js_1.isinstance(s, org_transcrypt___runtime___js_1.str))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('s has to be a str, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(s)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    var out = null;
    out = s.repeat(count);
    return out;
};
exports.contains = function (s, sub) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'sub':
                        var sub = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (!(org_transcrypt___runtime___js_1.isinstance(s, org_transcrypt___runtime___js_1.str))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('s has to be a str, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(s)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    if (!(org_transcrypt___runtime___js_1.isinstance(sub, org_transcrypt___runtime___js_1.str))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('sub has to be a str, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(sub)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    var result = false;
    result = s.includes(sub);
    return result;
};
exports.startswith = function (s, prefix) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'prefix':
                        var prefix = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (!(org_transcrypt___runtime___js_1.isinstance(s, org_transcrypt___runtime___js_1.str))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('s has to be a str, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(s)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    if (!(org_transcrypt___runtime___js_1.isinstance(prefix, org_transcrypt___runtime___js_1.str))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('prefix has to be a str, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(prefix)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    var result = false;
    result = s.startsWith(prefix);
    return result;
};
exports.isdigit = function (s) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (!(org_transcrypt___runtime___js_1.isinstance(s, org_transcrypt___runtime___js_1.str))) {
        var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('s has to be a str, not be of type {}'.format(org_transcrypt___runtime___js_1.py_typeof(s)));
        __except0__.__cause__ = null;
        throw __except0__;
    }
    var result = false;
    result = /^-{0,1}\d+$/.test(s);
    return result;
};
exports.isempty = function (s) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var result = false;
    result = (!s || 0 === s.length);
    return result;
};
exports.splitn = function (s, n) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                    case 'n':
                        var n = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var out = null;
    const regexp = new RegExp('.{1,' + n + '}', 'g');
    out = s.match(regexp) || [];
    return out;
};
exports.join = function (arr, sep) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'arr':
                        var arr = __allkwargs0__[__attrib0__];
                        break;
                    case 'sep':
                        var sep = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var s = null;
    s = arr.join(sep);
    return s;
};
exports.compare = function (a, b) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'a':
                        var a = __allkwargs0__[__attrib0__];
                        break;
                    case 'b':
                        var b = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (a == null) {
        return (b == null ? 0 : 1);
    }
    else if (b == null) {
        return -(1);
    }
    var out = 0;
    out = a.localeCompare(b, undefined, { sensitivity: 'base' });
    return out;
};
exports.equal = function (a, b) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'a':
                        var a = __allkwargs0__[__attrib0__];
                        break;
                    case 'b':
                        var b = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    return exports.compare(a, b) == 0;
};
exports.String = org_transcrypt___runtime___js_1.__class__('String', [org_transcrypt___runtime___js_1.object], {
    __module__: __name__,
    get from_utf8() {
        return org_transcrypt___runtime___js_1.__getcm__(this, function (cls, b) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'cls':
                                var cls = __allkwargs0__[__attrib0__];
                                break;
                            case 'b':
                                var b = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return cls(exports.from_utf8(b));
        });
    },
    get __init__() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, str) {
            if (typeof str == 'undefined' || (str != null && str.hasOwnProperty("__kwargtrans__"))) {
                ;
                var str = null;
            }
            ;
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'str':
                                var str = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            self._str = str || '';
        });
    },
    get _get_value() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return self._str;
        });
    },
    get __eq__() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, other) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'other':
                                var other = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            if (org_transcrypt___runtime___js_1.isinstance(other, exports.String)) {
                return self.__eq__(other.value);
            }
            return self.value == other;
        });
    },
    get __ne__() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, other) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'other':
                                var other = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return !(self.__eq__(other));
        });
    },
    get zfill() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, n) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'n':
                                var n = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.zfill(self.value, n));
        });
    },
    get zfillr() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, n) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'n':
                                var n = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.zfillr(self.value, n));
        });
    },
    get strip() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.strip(self.value));
        });
    },
    get lstrip() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.lstrip(self.value));
        });
    },
    get rstrip() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.rstrip(self.value));
        });
    },
    get lower() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.lower(self.value));
        });
    },
    get upper() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.upper(self.value));
        });
    },
    get py_replace() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, sub_old, sub_new) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'sub_old':
                                var sub_old = __allkwargs0__[__attrib0__];
                                break;
                            case 'sub_new':
                                var sub_new = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.py_replace(self.value, sub_old, sub_new));
        });
    },
    get replace_all() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, sub_old, sub_new) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'sub_old':
                                var sub_old = __allkwargs0__[__attrib0__];
                                break;
                            case 'sub_new':
                                var sub_new = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.String(exports.replace_all(self.value, sub_old, sub_new));
        });
    },
    get sprintf() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
                var argv = org_transcrypt___runtime___js_1.tuple([].slice.apply(arguments).slice(1, __ilastarg0__ + 1));
            }
            else {
                var argv = org_transcrypt___runtime___js_1.tuple();
            }
            return exports.String(exports.sprintf(self.value, ...argv));
        });
    },
    get utf8() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.to_utf8(self.value);
        });
    },
    get py_split() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, c, limit) {
            if (typeof c == 'undefined' || (c != null && c.hasOwnProperty("__kwargtrans__"))) {
                ;
                var c = null;
            }
            ;
            if (typeof limit == 'undefined' || (limit != null && limit.hasOwnProperty("__kwargtrans__"))) {
                ;
                var limit = null;
            }
            ;
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'c':
                                var c = __allkwargs0__[__attrib0__];
                                break;
                            case 'limit':
                                var limit = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.py_split(self.value, c, limit);
        });
    },
    get contains() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, sub) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'sub':
                                var sub = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.contains(self.value, sub);
        });
    },
    get startswith() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, prefix) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'prefix':
                                var prefix = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.startswith(self.value, prefix);
        });
    },
    get isdigit() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.isdigit(self.value);
        });
    },
    get isempty() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return exports.isempty(self.value);
        });
    }
});
Object.defineProperty(exports.String, 'value', org_transcrypt___runtime___js_1.property.call(exports.String, exports.String._get_value));
;
//# sourceMappingURL=tfchain.polyfill.encoding.str.map
//# sourceMappingURL=tfchain.polyfill.encoding.str.js.map